import { FileRouteTypes } from '@/routeTree.gen'
import { useCurrentUser } from '@/utils/hooks/useUser'
import { Tabs } from '@mantine/core'
import { Link, LinkProps, useChildMatches } from '@tanstack/react-router'
import { compact } from 'lodash-es'
import { HTMLAttributes, ReactNode } from 'react'
import styles from './UserPageTabs.module.css'

export interface UserPageTabsProps extends HTMLAttributes<HTMLDivElement> {
	username: string
}

export default function UserPageTabs({ username, ...props }: UserPageTabsProps) {
	const childRoute = useChildMatches()[0]
	const currentUser = useCurrentUser()
	const isMyUserProfilePage = username === currentUser?.username

	const tabs: { label: ReactNode; value: FileRouteTypes['id']; linkProps: LinkProps }[] = compact([
		{
			label: '动态',
			value: '/u/$username/',
			linkProps: {
				key: 'post',
				to: '/u/$username',
				params: {
					username,
				},
			},
		},
		{
			label: '相册',
			linkProps: {
				key: 'gallery',
				to: '/u/$username/gallery',
				params: {
					username,
				},
			},
			value: '/u/$username/gallery',
		},
		isMyUserProfilePage && {
			label: '收藏',
			linkProps: {
				key: 'collection',
				to: '/u/$username/collection',
				params: {
					username,
				},
			},
			value: '/u/$username/collection',
		},
		isMyUserProfilePage && {
			label: '我的圈子',
			linkProps: {
				key: 'topic',
				to: '/u/$username/topic',
				params: {
					username,
				},
			},
			value: '/u/$username/topic',
		},
	])

	return (
		<Tabs
			value={childRoute.routeId as FileRouteTypes['id']}
			classNames={{
				list: styles.list,
				tab: styles.tab,
			}}
		>
			<Tabs.List>
				{tabs.map((item) => (
					<Tabs.Tab
						key={item.value}
						value={item.value}
						fw={500}
						fz={16}
						lh={1.5}
						renderRoot={(props) => <Link {...item.linkProps} {...props} key={item.value} />}
					>
						{item.label}
					</Tabs.Tab>
				))}
			</Tabs.List>
		</Tabs>
	)
}
